import { Routes } from '@angular/router';
import { clusterRoutes } from './components/cluster/cluster.routes';
import { canActivateTeam } from './guards/home.guard';
import { userRouter } from './components/user/user.routing';
import { storeRoutes } from './components/store/store.routes';
import { RouterRoutes } from './components/routes/routes.route';
import { reportsRoutes } from './components/reports/reports.routes';
import { documentRouter } from './components/master-document/master-document.routing';
import { rightsRouter } from './components/role-rights/add-rights.routing';
import { roleGuard } from './guards/role.guard';
import { assignmentRouter } from './components/assignment/assignment.route';
import { approvalsRouter } from './components/approvals/approvals.route';
import { uomRoutes } from './components/uom/uom.routes';
import { productRoutes } from './components/product/product.routes';
import { hoardingSiteRoutes } from './components/hoarding-site/hoarding-site.routes';
import { loginGuard } from './guards/login.guard';

export const routes: Routes = [
    {
        path: '',
        loadComponent: () => import('./components/layout/layout.component').then((c) => c.LayoutComponent),
        canActivate: [canActivateTeam],
        children: [
            {
                path: 'user',
                children: userRouter,
                canActivate: [roleGuard],
                data:{
                    title:"employee"
                }
            },
            {
                path: 'uom',
                children: uomRoutes,
                canActivate: [roleGuard],
                data: {
                    title: "uom"
                }
            },
            {
                path: 'product',
                children: productRoutes,
                canActivate: [roleGuard],
                data: {
                    title: "product"
                }
            },
            {
                path: 'blockroute',
                redirectTo: 'blockROute',
                pathMatch: 'full'
            },
            {
                path: 'blockRoute',
                redirectTo: 'blockROute',
                pathMatch: 'full'
            },
            {
                path: 'routes',
                redirectTo: 'route',
                pathMatch: 'full'
            },
            {
                path: 'blockROute',
                children: clusterRoutes,
                canActivate: [roleGuard],
                data: {
                    title: "blockRoute"
                }
            },
            {
                path: "",
                redirectTo: 'user',
                pathMatch: "full",
                data: {
                    title: "employee"
                }
            },
            {
                path: 'checkInList',
                loadComponent: () => import('./components/user/pages/check-in-details/check-in-details.component').then((c) => c.CheckInDetailsComponent),
                canActivate: [roleGuard],
                data: {
                    title: "checkIn"
                }
            },
            {
                path: 'checkInList/:id',
                loadComponent: () => import('./components/user/pages/check-in-details/check-in-details.component').then((c) => c.CheckInDetailsComponent),
                canActivate: [roleGuard],
                data: {
                    title: "checkIn"
                }
            },
            {
                path: 'store',
                children: storeRoutes,
                canActivate: [roleGuard],
                data: {
                    title: "store"
                }
            },
            {
                path: 'route',
                children: RouterRoutes,
                canActivate: [roleGuard],
                data: {
                    title: "routeMaster"
                }
            },
            {
                path: 'settings',
                loadComponent: () => import('./components/settings/settings.component').then(m => m.SettingsComponent),
                canActivate: [roleGuard],
                data: {
                    title: "settings"
                }
            },
            {
                path: 'reports',
                canActivate: [roleGuard],
                children : reportsRoutes,
                data: {
                    title: "reports"
                }
            },
            {
                path: 'documents',
                children: documentRouter,
                canActivate: [roleGuard],
                data: {
                    title: "masterDocuments"
                }
            },
            {
                path: 'rights',
                children: rightsRouter,
                canActivate: [roleGuard],
                data:{
                    title:"rights"
                }
            },
            {
                path:'assignment',
                children:assignmentRouter,
                canActivate: [roleGuard],
                data:{
                    title:"assignments"
                }
            },
            {
                path:'approvals',
                children:approvalsRouter,
                canActivate: [roleGuard],
                data:{
                    title:"approvals"
                }
            },
            {
                path: 'hoarding',
                children: hoardingSiteRoutes,
                canActivate: [roleGuard],
                data: {
                    title: "hoarding"
                }
            }
        ]
    },
    {
        path: 'login',
        loadComponent: () => import('./components/login/login.component').then((c) => c.LoginComponent),
        canActivate: [loginGuard],
    },
];
